import styled from 'styled-components'

export const RangeInputContainer = styled.div`
    transform: rotate(-90deg);
    width: 130px;
    position: absolute;
    top: 55px;
    left: -55px;
    z-index: 9;
`
